import axiosClient from "../../../../../system/helpers/axiosConfig";
export const getAdminChat = (id) => {
  return axiosClient.get(`/api/admin/im/view/${id}`).then((r) => r.data);
};
